import { convertThousands } from '@l2p/apps-shared'
import { useCurrentCurrency } from '@l2p/swr-hooks'
import { TournamentPosition, TournamentScore } from '@l2p/tournament-api'
import { useTranslations } from 'next-intl'
import React from 'react'
import FirstLeader from './FirstLeader'
import styles from './styles.module.scss'

interface WithPlayersProps {
  topPlayers: Array<TournamentScore & { prize?: any }>
  emptyPlayers: Array<any>
  withFirstLeaderIcon?: boolean
  isFinished?: boolean
  tournamentPosition?: TournamentPosition | null
  withPrize?: boolean
}
const WithPlayers: React.FC<WithPlayersProps> = ({
  topPlayers,
  emptyPlayers,
  withFirstLeaderIcon = false,
  isFinished,
  tournamentPosition,
  withPrize = false,
}) => {
  const t = useTranslations('translation')
  const currentCurrency = useCurrentCurrency()

  return (
    <>
      {topPlayers.map((item, idx) => (
        <div
          key={String(item.user.nickname) + idx}
          className={`${styles.container} ${idx === 0 ? 'highlight' : ''} ${
            tournamentPosition && tournamentPosition.position === idx + 1
              ? styles.containerCurrent
              : ''
          }`}
        >
          <div>
            {idx === 0 && withFirstLeaderIcon && <FirstLeader />}
            {idx + 1}
          </div>
          <div>{item.user.nickname || t('anonymous')}</div>
          <div>
            {item?.value || item?.value === 0
              ? convertThousands(item?.value.toFixed(2))
              : convertThousands(Number(item?.totalSpent || 0).toFixed(2) || 0)}
          </div>
          {withPrize || isFinished ? (
            item.prize ? (
              <div>
                {item.prize.value?.amount > 0
                  ? `${item.prize.value?.amount} ${currentCurrency}`
                  : item.prize.value?.freeSpins
                  ? `${item.prize.value.freeSpins} ${t(
                      'fs',
                    ).toLocaleUpperCase()}`
                  : item.prize?.value?.loyaltyExp
                  ? `${item.prize.value.loyaltyExp} ${t(
                      'loyalExp',
                    ).toLocaleUpperCase()}`
                  : item.prize?.value?.loyaltyPoints
                  ? `${item.prize.value.loyaltyPoints} ${t(
                      'points',
                    ).toLocaleUpperCase()}`
                  : item.prize.value.physicalReward
                  ? item.prize.value.physicalReward.toLocaleUpperCase()
                  : ''}
                {item.prize.value?.bonus
                  ? `${item.prize.value?.bonus.percents || ''} ${
                      item.prize.value?.bonus?.amount
                        ? item.prize.value?.bonus?.amount
                        : ''
                    } ${
                      item.prize.value?.bonus?.freespins
                        ? item.prize.value?.bonus?.amount
                          ? '+ '
                          : '' + item.prize.value?.bonus.freespins + t('fs')
                        : ''
                    }`
                  : ''}
              </div>
            ) : (
              <div>...</div>
            )
          ) : null}
        </div>
      ))}
      {!isFinished &&
        emptyPlayers.map((item, idx) => (
          <div key={`empty_player_${idx}`}>
            <div>{item.number}</div>
            <div>...</div>
            <div>...</div>
          </div>
        ))}
    </>
  )
}

export default WithPlayers
